import { Link } from "react-router-dom";
import { FaInstagram, FaYoutube, FaDiscord } from "react-icons/fa";
const Contact = () => {
  return (
    <footer className="w-full max-md:text-sm">
      <section
        id="contact-1"
        className="pt-6 font-minecraft drop-shadow-2xl shadow-black"
      >
        <h2 className="px-8 text-5xl font-bold text-left mb-6 drop-shadow-2xl">
          Contact Us
        </h2>
        <p className="text-left text-xl px-8 drop-shadow-xl">
          Ready to start your next project?{" "}
          <Link to="/Contact" className="text-blue-400 underline">
            Contact us
          </Link>
          .
        </p>
      </section>

      <section
        id="contact"
        className="py-4 font-minecraft drop-shadow-md flex items-center justify-between text-lg shadow-black max-md:flex-col max-md:justify-center max-md:gap-4"
      >
        <div>
          <Link to="/tos" className="px-8 drop-shadow-xl text-white hover:underline">
            Terms of Service
          </Link>
        </div>
        <div className="flex-grow mx-4 border-t-2 border-gray-600 max-md:w-full" />
        <div>
          <p className="px-8 drop-shadow-xl text-white text-center">Nova Creations ;)</p>
        </div>
        <div className="drop-shadow-xl max-md:hidden flex justify-end pr-10 gap-8">
          <a href="https://discord.gg/VwC9j33bPD">
            <FaDiscord size={34} />
          </a>
          <a href="https://www.youtube.com/@NovaCreationsMC" className="flex items-center">
            <FaYoutube size={34} />
          </a>
          <a href="https://www.instagram.com/_.novacreations._/">
            <FaInstagram size={34} />
          </a>
        </div>
      </section>
    </footer>
  );
};

export default Contact;
